import React, { useContext, useEffect, useState } from "react";
import ShowPlaid from "./ShowPlaid";
import DEATH_API from "../../apis/death.api";
import { MODULE_API } from "../../apis";
import List from "../styledComponents/Table/List";
import ListPaginated from "../styledComponents/Table/ListPaginated";
import menuIcon from "../../assets/images/DeathModuleNew/Menu.png";
import moreIcon from ".../../assets/images/DeathModuleNew/more_horiz1.png";
import matchImg from ".../../assets/images/DeathModuleNew/Checkbox.png";
import plaidIcon from "../../assets/images/plaidLogo1.png";
import SearchIcon from "../../assets/images/Search.svg";
import deleteIcon from "../../assets/images/DeathModuleNew/delete.png";
import assetHomeIcon from "../../assets/images/asset.png";
import debtImage from "../../assets/images/debt.png";
import networthImage from "../../assets/images/networth.png";
import Loader from "../../components/styled-components/loader/loader";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import warningSign from "../../assets/SVGs/warningSign.svg"
import {
  setRefreshTime,
  setRefreshTimeAsset,
} from "../../redux/slices/itemsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal } from "antd";
import moment from "moment";
import "./Plaidmain.css";
import swal from "sweetalert";
import PlaidSyncProgressLoader from "../../components/PlaidSyncProgressLoader";
import { ProgressContext } from "../../utils/ProgressContext";
import ModalVideo from "../ModuleVideos/ModalVideo";

const PlaidMainNew = () => {
  const [link, setLink] = useState();
  const { startLoading, stopLoading, loadingProgress } =
    useContext(ProgressContext);

  const [loading, setLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);
  const [addbank, setAddbank] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [updatedObject, setUpdateObject] = useState(null);
  const [detailsModal, setDetailsModal] = useState(false);
  const [syncPayload, setSyncPayload] = useState([]);
  const [syncModal, setSyncModal] = useState(false);
  const [addAccountModal, setAddAccountModal] = useState(false);
  const [matchData, setMatchData] = useState(null);
  const [matchValues, setMatchValues] = useState(null);

  const [previousData, setPreviousData] = useState(null);
  const [addPlanPayload, setaddPlanPayload] = useState(null);
  const [addPlanAccountData, setAddPlanAccountData] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [dropdown, setDropdown] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [accountTypeModal, setAccountTypeModal] = useState(false);
  const [accountSelected, setAccountSelected] = useState(null);

  const [bankDetailsLatest, setBankDetailsLatest] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [bankDropdown, setBankDropdown] = useState(false);
  const [bankModal, setBankModal] = useState(false);
  const [bankloading, setBankLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [bankList, setBankList] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();

  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const refreshTime = useSelector(
    (state) => state.rootReducer.itemsInfo.refreshTimeAsset
  );

  const handleOpenBankModal = () => {
    setBankModal(true);
    getPlaidBankList(1);
  };
  const handleCancelBankModal = () => {
    setBankModal(false);
    setTotalPages(1);
    setCurrentPage(1);
  };

  const handleOpenAccountTypeModal = () => {
    setAccountTypeModal(true);
  };
  const handleCancelAccountTypeModal = () => {
    setAccountTypeModal(false);
    setAccountSelected(null);
  };

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } =
      document.getElementById("bankDisplay");
    console.log("Scroll Top:", scrollTop);
    console.log("Scroll Height:", scrollHeight);
    console.log("Client Height:", clientHeight);

    if (scrollTop + clientHeight >= scrollHeight) {
      console.log("Bottom of the scroll reached.");
      console.log("pageee", currentPage, totalPages);
      if (currentPage < totalPages) {
        console.log("Fetching more items...");
        getPlaidBankList(currentPage + 1);
      }
    }
  };
  const getPlaidBankList = async (page) => {
    try {
      setBankLoading(true);
      const response = await DEATH_API.getPlaidBanks(page);
      // Assuming the bank list is in the response.data
      if (response && response.data) {
        const updatedBankList = [...bankList, ...response.data.institutions];
        // Sort the merged bank list alphabetically by name
        const sortedInstitutions = updatedBankList.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        // Set the sorted list in state
        setBankList(sortedInstitutions);
        // const sortedInstitutions = response.data.institutions.sort((a, b) =>
        //   a.name.localeCompare(b.name)
        // );
        // setBankList((prevItems) => [...prevItems, ...response.data.institutions]);
        setTotalPages(
          Math.ceil(response.data.total && response.data.total / 50)
        );
        setCurrentPage(page);
      }
      setBankLoading(false);
    } catch (error) {
      setBankLoading(false);
      console.error("Error fetching Plaid bank list:", error);
    }
  };
  const handleKeypress = (e) => {
    if (e.key === "Enter") {
      handleSearch(e);
    }
  };
  const hanldeAccountSelected = async (type) => {
    const products = [
      // "assets",
      "auth",
      "transactions",
      "identity",
      // "investments",
      // "liabilities",
    ];
    // Add products based on the selected type
    if (type === "Investment") {
      products.push(...["investments", "assets"]);
    } else if (type === "Liability") {
      products.push("liabilities");
    } else if (type === "Both Types") {
      products.push(...["investments", "assets", "liabilities"]);
    }
    console.log("bank", type, accountSelected);
    let matchedProducts;
    if (
      accountSelected &&
      accountSelected.name &&
      accountSelected.name === "Capital One"
    ) {
      const updatedProducts = products.filter(
        (product) => product !== "identity"
      );
      // Filter the bank products to match the updated products array
      matchedProducts = accountSelected.products.filter((product) =>
        updatedProducts.includes(product)
      );
    } else {
      matchedProducts = accountSelected.products.filter((product) =>
        products.includes(product)
      );
    }
    let payload = {
      products: matchedProducts,
      routingNumber:
        accountSelected.routing_numbers &&
        accountSelected.routing_numbers[0] &&
        accountSelected.routing_numbers[0],
      // institutionId:bank.institution_id && bank.institution_id,
    };
    console.log("paylllll", payload, accountSelected);
    setAccountTypeModal(false);
    createPlaidLinkToken(payload);
  };
  const hanldeBankSelect = async (bank) => {
    setAccountSelected(bank);
    setBankModal(false);
    handleOpenAccountTypeModal();
    setSearchQuery("");
    // const products = [
    //   "assets",
    //   "auth",
    //   "transactions",
    //   "identity",
    //   "investments",
    //   "liabilities",
    // ];

    // console.log("bank", bank);
    // let matchedProducts;
    // if (bank && bank.name && bank.name === "Capital One") {
    //   const updatedProducts = products.filter(
    //     (product) => product !== "identity"
    //   );
    //   // Filter the bank products to match the updated products array
    //   matchedProducts = bank.products.filter((product) =>
    //     updatedProducts.includes(product)
    //   );
    // } else {
    //   matchedProducts = bank.products.filter((product) =>
    //     products.includes(product)
    //   );
    // }
    // let payload = {
    //   products: matchedProducts,
    //   routingNumber:
    //     bank.routing_numbers &&
    //     bank.routing_numbers[0] &&
    //     bank.routing_numbers[0],
    //   // institutionId:bank.institution_id && bank.institution_id,
    // };
    // console.log("paylllll", payload, bank);
    // createPlaidLinkToken(payload);
    // setBankLoading(true);
    // setBankLoading(false);
  };
  const handleCancelSearch = async (e) => {
    e.preventDefault();
    setSearchQuery("");
    setBankDetails([]);
    getPlaidBankList(1);
  };
  const handleSearch = async (e) => {
    e.preventDefault();
    let SearchValue = searchQuery;
    try {
      setBankLoading(true);
      setBankList([]);
      const response = await DEATH_API.searchBank(SearchValue);
      if (response.data) {
        setBankList(response.data.institutions);
      }
      setBankLoading(false);
    } catch (error) {
      setBankLoading(false);
      console.log(error);
    }
  };
  const cols = [
    // {
    //   title: "ID",
    //   dataIndex: "id",
    //   render: (record) => (record ? record : "N/A"),
    // },
    {
      title: "Account Name",
      dataIndex: "bankName",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.bankName ? (
          <div className="plaid-unauthorized">
            <div style={{ textAlign: "center",width:"85%" }}>
              {record.accountName && (
                <span style={{ color: "black" }}>{record.accountName}</span>
              )}
              <div>{record.bankName}</div>
            </div>
             {record.accountStatus && record.accountStatus === "Unauthorized" &&
            <button 
                style={{ background: "transparent", border: "none",width:"12%" }} 
                onClick={() => authorizeBank(record)}
              >
                <img src={warningSign} alt="Unauthorized warning" />
              </button>
            }
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Account Type",
      dataIndex: "subType",
      render: (record) =>
        record
          ? record
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")
          : "N/A",
    },
    {
      title: "Account Number",
      dataIndex: "mask",
      render: (record) => (record ? "****" + record : "N/A"),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      render: (record) =>
        record
          ? "$" +
            record
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "$0.00",
      // render: (record) => (record && record
      //   ? !isNaN(record)
      //     ? `${
      //         "$" +
      //         record
      //           .toFixed(2)
      //           .toString()
      //           .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      //       }`
      //     : "N/A"
      //   : "N/A"),
    },
    {
      title: "Match Found",
      dataIndex: "matchFound",
      render: (fileName, record) => {
        return record.status !== "Added to Plan" &&
          record.matchFound &&
          record.count > 0 ? (
          <div>
            <img
              style={{ cursor: "pointer", marginLeft: "1rem" }}
              src={matchImg}
              alt="matchImg"
              height={30}
              width={30}
              onClick={() => {
                syncSinglePlaid(record.bankName, record.mask);
              }}
            ></img>
            {record.count && <span>{record.count}</span>}
          </div>
        ) : null;
      },
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (fileName, record) => {
    //     return record.status ? (
    //       <button
    //         className="saveStatusbutton"
    //         style={{
    //           width: "100%",
    //           background:
    //             (record.status === "Exist in Plan" && "#E13C25") ||
    //             (record.status === "Up To Date" && "#09A84D"),
    //         }}
    //         onClick={() => {
    //           if (record.status === "Add New Account") {
    //             setSelectedIndex(record.id);
    //             addAccountToPlaid(record.subType);
    //           }
    //         }}
    //       >
    //         {record.status}
    //       </button>
    //     ) : null;
    //   },
    // },
    {
      title: "Status",
      dataIndex: "status",
      render: (fileName, record) => {
        return record.status ? (
          <div
            // className="saveStatusbutton"
            style={{
              width: "100%",
              fontWeight: "bold",
              color:
                (record.status === "Exist in Plan" && "#E13C25") ||
                (record.status === "Up To Date" && "#09A84D") ||
                (record.status === "Add New Account" && "#2a3da3"),
            }}
          >
            <div>
              {" "}
              {/*
        {(record.status === "Add New Account" && "New Account (Add Now)") || record.status}
         */}
              {record.status === "Add New Account" && "New Account (Add Now)"}
              {record.status === "Exist in Plan" && "We found a match"}
              {record.status !== "Add New Account" &&
                record.status !== "Exist in Plan" &&
                record.status}
            </div>
            {record.plaidStatus && (
              <span style={{ color: "black" }}>{record.plaidStatus}</span>
            )}
          </div>
        ) : null;
      },
    },
    {
      title: "Add to Asset Planet?",
      dataIndex: "status",
      render: (fileName, record) => {
        return record.status
          ? (record.status === "Add New Account" ||
              record.status === "Exist in Plan") && (
              <button
                className="saveStatusbutton"
                style={{
                  width: "100%",
                  // background:
                  //   (record.status === "Exist in Plan" && "#E13C25") ||
                  //   (record.status === "Up To Date" && "#09A84D"),
                }}
                onClick={() => {
                  if (
                    record.status === "Add New Account" ||
                    record.status === "Exist in Plan"
                  ) {
                    setSelectedItemId(record.itemId);
                    setSelectedIndex(record.id);
                    addAccountToPlaid(record.subType);
                    setSelectedStatus(record.status);
                  }
                }}
              >
                ADD
              </button>
            )
          : null;
      },
    },
    // {
    //   title: "Add to Asset Planet",
    //   dataIndex: "status",
    //   render: (fileName, record) => {
    //     return (
    //       <div style={{ display: "flex", justifyContent: "center" }}>
    //         {record.status && record.status === "Exist in Plan" && (
    //           <button
    //             className="saveStatusbutton"
    //             onClick={() => {
    //               addAssetToPlan(record.id);
    //             }}
    //             style={{ width: "fit-content", background: "#09A84D" }}
    //           >
    //           </button>
    //         )}
    //         {record.status && record.status === "Add New Account" && (
    //           <button
    //             className="saveStatusbutton"
    //             onClick={() => {
    //               addAssetToPlan(record.id);
    //             }}
    //             style={{ width: "fit-content" }}
    //           >
    //             Add
    //           </button>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: "Transaction Details",
    //   render: (record, index) => {
    //     return (
    //       <div key={index}>
    //         {" "}
    //         <img
    //           style={{ cursor: "pointer", marginLeft: "1rem" }}
    //           src={moreIcon}
    //           alt="moreIcon"
    //           onClick={() => {
    //             console.log("recode", record.id);
    //             getSelectedRow(record.id);
    //           }}
    //         ></img>{" "}
    //       </div>
    //     );
    //   },
    // },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                console.log("recode", record.id);
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "8px 16px",
              }}
            >
              <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteSelectedRow(record.id);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    console.log("link", link);
  }, [link]);
  useEffect(() => {
    getBankDetails();
  }, []);
  useEffect(() => {
    if (addbank !== null) {
      console.log("adding bank");
      getBankTransactions();
    }
  }, [addbank]);
  const getBankTransactions = async () => {
    await getBankDetails();
    // await getUserTransactions();
  };
  const getUserTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBankAccountDetails();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getSelectedRow = async (id) => {
    setSelectedIndex(id);
    // try {
    //   setLoading(true);
    //   let data = await DEATH_API.getBankAccountDetails(id);
    //   if (data && data.data) {
    //     setUpdateObject(data.data);
    //   }
    //   setLoading(false);
    // } catch (error) {
    //   console.log(error);
    //   setLoading(false);
    // }
    // setDetailsModal(true);
  };

  const addAssetToPlan = async () => {
    setSyncModal(false);

    const plaidModule =
      matchData && matchData.find((item) => item.managedBy === "Plaid");

    const plaidModuleName = plaidModule ? plaidModule.module.name : null;
    console.log("addPlanPayload", addPlanPayload, plaidModuleName);
    swal({
      title: "Are you sure?",
      content: {
        element: "div",
        attributes: {
          innerHTML: `Are you sure you want to ${
            plaidModuleName
              ? `unlink <strong>${plaidModuleName}</strong> and Link <strong>${
                  addPlanPayload && addPlanPayload.moduleName
                }</strong>?`
              : `Link <strong>${
                  addPlanPayload && addPlanPayload.moduleName
                }</strong>?`
          }`,
        },
      },
      // text: `Are you sure you want to ${plaidModuleName ? `unlink ${plaidModuleName} and Link ${addPlanPayload && addPlanPayload.moduleName}?` :`Link ${addPlanPayload && addPlanPayload.moduleName}?`}`,
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Link it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let data = await DEATH_API.addToPlan({
            id: addPlanPayload && addPlanPayload.id,
            clientModuleId: addPlanPayload && addPlanPayload.clientModuleId,
            atp: "no",
          });
          if (data && data.status === 200) {
            await getBankDetails();
            swal("Success", data.message, "success");
          }
          if (data.status === 400) {
            if (data.message == "PLAID_ITEM_LOGIN_REQUIRED") {
              try {
                // setLoading(true);
                setLink(null);
                let data = await DEATH_API.createPlaidLinkToken(
                  addPlanPayload.id && addPlanPayload.id
                );
                if (data.data) {
                  setLink(data.data.link_token);
                }
                // setLoading(false);
              } catch (error) {
                console.log(error);
                // setLoading(false);
              }
            } else {
              swal("Oops!", data.message, "error");
            }
            // swal("Oops!", data.message, "error");
          }
          // if (data && data.data) {
          //   setUpdateObject(data.data);
          // }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Account is safe :)", "error");
      }
    });

    // try {
    //   setLoading(true);
    //   let data = await DEATH_API.addToPlan({
    //     id: addPlanPayload && addPlanPayload.id,
    //     clientModuleId: addPlanPayload && addPlanPayload.clientModuleId,
    //     atp:"no",
    //   });
    //   if(data && data.status===200){
    //     await getBankDetails();
    //     swal("Success", data.message, "success")
    //   }
    //   if(data.status===400){
    //     swal("Oops!", data.message, "error")
    //   }
    //   // if (data && data.data) {
    //   //   setUpdateObject(data.data);
    //   // }
    //   setLoading(false);
    // } catch (error) {
    //   console.log(error);
    //   setLoading(false);
    // }
    setaddPlanPayload(null);
  };

  // const syncAllPlaid = async () => {
  //   try {
  //     setLoading(true);
  //     let data = await DEATH_API.syncAllPlaidRecords(
  //       syncPayload && syncPayload
  //     );
  //     await refreshDataPlaid();
  //     if (data && data.status === 200) {
  //       await getBankDetails();
  //     }
  //     if (data && data.status === 400) {
  //       await getBankDetails();
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  // sync

  const syncAllPlaid = async () => {
    try {
      const interval = startLoading();

      let data = await DEATH_API.syncAllPlaidRecords(syncPayload);

      await refreshDataPlaid();
      if (data && data.status === 200) {
        await getBankDetails();
      }
      if (data && data.status === 400) {
        await getBankDetails();
      }
      clearInterval(interval);
      stopLoading();
    } catch (error) {
      console.log(error);
      stopLoading(0);
    }
  };

  const syncPlaidRecords = async () => {
    try {
      setLoading(true);
      let response = await DEATH_API.getBankDetails();
      let obj = [];
      if (response && response.data) {
        response.data.map((item, idx) => {
          obj.push({
            bankName: item.bankName,
            mask: item.mask,
            accessToken: item.accessToken,
          });
        });
      }

      let data = await DEATH_API.syncAllPlaidRecords(obj && obj);
      // if (data && data.status === 200) {
      //   await getBankDetails();
      // }
      // if (data && data.status === 400) {
      //   await getBankDetails();
      // }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const refreshAssetModule = async () => {
    try {
      // setLoading(true);
      const response = await MODULE_API.refreshAssetModule();
      if (
        response &&
        response.status === 200 &&
        response.updatedAt &&
        response.updatedAt
      ) {
        dispatch(setRefreshTimeAsset(response.updatedAt));
      }
      // console.log("response",response)
      // if(response && response.status===429){
      //   swal("Oops!",response.message,"error");
      // }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  const refreshLiabilityModule = async () => {
    try {
      // setLoading(true);
      const response = await DEATH_API.refreshLiability();
      console.log("response refresf", response.data);
      if (
        response &&
        response.status === 200 &&
        response.updatedAt &&
        response.updatedAt.updatedAt
      ) {
        dispatch(setRefreshTime(response.updatedAt.updatedAt));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  const updatePayment = () => {
    history.push("/payment");
  };
  const refreshDataPlaid = async () => {
    try {
      // setLoading(true);
      const refreshData = await DEATH_API.refreshBanksData(
        syncPayload && { accounts: syncPayload }
      );
      console.log("refreshData", refreshData);
      if (refreshData && refreshData.status === 200) {
        await refreshLiabilityModule();
        await refreshAssetModule();
      }
      if (refreshData && refreshData.status === "ERROR") {
        // swal("Oops!",refreshData.message,"error");
        swal({
          title: "Oops!",
          text: refreshData.message,
          icon: "warning",
          type: "warning",
          buttons: {
            upgrade: {
              text: "Upgrade",
              value: "upgrade",
              visible: true,
            },
            ok: {
              text: "Ok",
              value: "ok",
              visible: true,
            },
          },
        }).then((value) => {
          console.log("Button value clicked:", value); // Debugging line to show the value
          switch (value) {
            case "upgrade":
              console.log("calling upgrade");
              updatePayment();
              break;

            case "ok":
              console.log("calling ok");
              break;

            default:
              console.log("No action taken");
              break;
          }
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const syncSinglePlaid = async (bankName, mask) => {
    try {
      setLoading(true);
      let data = await DEATH_API.syncSinglePlaidRecord({
        bankName: bankName,
        mask: mask,
      });
      if (data && data.data && data.previousData) {
        // const matchedAccounts = data.data.filter(item =>
        //   (item.accountId === data.previousData.id) || (item.accountId === null)
        // );
        // setMatchData(matchedAccounts);
        setMatchData(data.data);
      }
      if (data && data.previousData) {
        setPreviousData(data.previousData);
      }
      if (data && data.value) {
        setMatchValues(data.value);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setSyncModal(true);
  };

  const addAccountToPlaid = async (subType) => {
    if (
      subType === "credit card" ||
      subType === "mortgage" ||
      subType === "student" ||
      subType === "loan" ||
      subType === "auto" ||
      subType === "business" ||
      subType === "commercial" ||
      subType === "construction" ||
      subType === "consumer" ||
      subType === "home equity" ||
      subType === "overdraft" ||
      subType === "line of credit"
    ) {
      try {
        setLoading(true);
        let data = await MODULE_API.insuraceAllocation(
          "Liabilities and Credit"
        );
        if (data) {
          setAddPlanAccountData(data);
        }

        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let data = await MODULE_API.assetAllocation();
        if (data) {
          setAddPlanAccountData(data);
        }

        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }

    setAddAccountModal(true);
  };
  const handleAssetSelect = async (name, subType) => {
    setSelectedData({
      module: name,
      subType: subType,
    });
    setAddAccountModal(false);
    try {
      setLoading(true);
      let data = await DEATH_API.addToPlan({
        module: name,
        subType: subType,
        id: selectedIndex && selectedIndex,
        atp:
          selectedStatus && selectedStatus === "Exist in Plan" ? "yes" : "no",
      });
      if (data && data.status === 200) {
        await getBankDetails();
        swal("Success!", data.message, "success");
      }
      if (data && data.status === 400) {
        if (data.message == "PLAID_ITEM_LOGIN_REQUIRED") {
          try {
            // setLoading(true);
            setLink(null);
            let data = await DEATH_API.createPlaidLinkToken(
              selectedIndex && selectedIndex
            );
            if (data.data) {
              setLink(data.data.link_token);
            }
            // setLoading(false);
          } catch (error) {
            console.log(error);
            // setLoading(false);
          }
        } else {
          swal("Oops!", data.message, "error");
        }
        // swal("Oops!", data.message, "error")
      }
      // if (data && data.data) {
      //   setUpdateObject(data.data);
      // }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setDetailsModal(false);
    setUpdateObject(null);
  };
  const handleCancelAdd = () => {
    setAddAccountModal(false);
    setSelectedData(null);
  };
  const handleCancelSyncModal = () => {
    setSyncModal(false);
    setMatchData(null);
    setMatchValues(null);
    setPreviousData(null);
    setaddPlanPayload(null);
  };
  const createPlaidLinkToken = async (payload) => {
    try {
      setLoading(true);
      setLink(null);
      let data = await DEATH_API.createPlaidLinkToken(null, payload);
      if (data.data) {
        setLink(data.data.link_token);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const authorizeBank = async (payload) => {
    try {
      setLoading(true);
      setLink(null);
       let data = await DEATH_API.createPlaidLinkToken(
        payload.id && payload.id
        );
       if (data.data) {
        setLink(data.data.link_token);
       }
       setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
     }
  };
  const deleteSelectedRow = async (idx) => {
    console.log("index of deleted", idx);
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this account from your Plan?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.DeletePlaidAccount(idx);
          setLoading(false);
          getBankDetails();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Account has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Account is safe :)", "error");
      }
    });
  };
  function findBankIdsByBankName(data, bankName) {
    const bankIds = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].bankName === bankName) {
        bankIds.push(data[i].id);
      }
    }
    return bankIds;
  }
  const deleteAllBanks = async (name) => {
    console.log("index of deleted", name, bankDetails);
    let bankIds = findBankIdsByBankName(bankDetails, name);
    console.log("bankIds", bankIds);
    swal({
      title: "Are you sure you want to Unlink?",
      text: "1. Your subscription status will not change. You may continue to be billed on this account. \n 2. Custom categories and edits will be permanently deleted. \n 3. All historical data will be permanently deleted.\n 4. Alerts on this account will be turned off.",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Unlink it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.DeleteAllAccount(name, bankIds);
          setLoading(false);
          getBankDetails();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your accounts have been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Accounts are safe :)", "error");
      }
    });
  };

  const getBankDetails = async () => {
    try {
      if (!loadingProgress) {
        setLoading(true);
      }
      let data = await DEATH_API.getBankDetails();
      setSyncPayload([]);
      let obj = [];
      let bankData = {};
      if (data && data.data) {
        data.data.forEach((item) => {
          if (!bankData[item.bankName]) {
            bankData[item.bankName] = [];
          }
          bankData[item.bankName].push({
            ...item,
            bankName: item.bankName,
            mask: item.mask,
          });
        });

        console.log("datadatata", bankData);
        setBankDetailsLatest(bankData);

        setBankDetails(data.data);
        data.data.map((item, idx) => {
          obj.push({
            bankName: item.bankName,
            mask: item.mask,
            accessToken: item.accessToken,
          });
        });
      }
      console.log("objobj", obj);
      setSyncPayload((prevState) => [...prevState, ...obj]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const accountTypes = [
    {
      id: 1,
      name: "Investment",
      title: "Asset (Checking, Savings, etc.)",
      image: assetHomeIcon,
    },
    {
      id: 2,
      name: "Liability",
      title: "Credit (Credit Card, HELOC, Loan, etc.)",
      image: debtImage,
    },
    {
      id: 3,
      name: "Both Types",
      title: "Both Types",
      image: networthImage,
    },
  ];

  return (
    <div className="profileMain">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1
          style={{
            fontFamily: "Poppins",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          Link Bank
        </h1>
        <div className="video-button-main-container">
          <ModalVideo module="Link Bank" autoOpen={true} />
        {userRole && userRole !== "FreeTrail" && (
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            {refreshTime &&
              `Updated at: ${moment(refreshTime)
                .local()
                .format("MM/DD/YYYY [at] hh:mmA")}`}
            <button
              className={
                syncPayload && syncPayload.length === 0
                  ? "addbuttonassets disableButton"
                  : "addbuttonassets"
              }
              disabled={syncPayload && syncPayload.length === 0}
              style={{ background: "#09A84D" }}
              // disabled={syncPayload && syncPayload ? false : true}
              onClick={() => {
                syncAllPlaid();
              }}
            >
              Refresh
            </button>
            <button
              className="addbuttonassets"
              onClick={() => {
                // createPlaidLinkToken();
                handleOpenBankModal();
              }}
            >
              + Add Bank
            </button>
          </div>
        )}
        </div>
      </div>
      {link && (
        <ShowPlaid
          link={link}
          tokenState={(token) => setAddbank(token)}
          syncPlaidRecords={syncPlaidRecords}
        />
      )}

      <div
        className="rolesTable"
        style={{
          marginTop: "10px",
          height: "calc(100vh - 220px)",
          overflow: "auto",
        }}
      >
        {/*   <div className="RolesHeader">
          <div className="RoleTitle">Bank Details</div>
        </div>
      <List cols={cols} rows={bankDetails} /> */}
        {userRole && userRole === "FreeTrail" && (
          <div className="role-based-text">
            You don't have the required permission to link a bank account in the
            Free Role, You might need an upgraded role.
          </div>
        )}
        {bankDetailsLatest &&
          Object.keys(bankDetailsLatest).map((bankName, index) => (
            <div
              key={index}
              className="RolesHeader"
              style={{ display: "contents" }}
            >
              <div
                className="RoleTitle"
                style={{ display: "flex" }}
                onClick={() => {
                  setSelectedBank(bankName);
                }}
              >
                {bankName}
                <div style={{ position: "relative" }}>
                  <div
                    onClick={() => {
                      setBankDropdown(true);
                    }}
                    style={{
                      cursor: "pointer",
                      marginRight: "1rem",
                      padding: "0px 16px",
                      width: "5px",
                    }}
                  >
                    <img src={menuIcon} alt="menu-icon"></img>
                  </div>
                  {bankDropdown && selectedBank === bankName && (
                    <React.Fragment>
                      <div
                        onClick={() => {
                          setBankDropdown(false);
                        }}
                        className=""
                        style={{
                          position: "fixed",
                          width: "100vw",
                          height: "100vh",
                          background: "black",
                          opacity: "0.1",
                          top: "0",
                          left: "0",
                          right: "0",
                          bottom: "0",
                          zIndex: "999",
                        }}
                      ></div>

                      <div className="dropdownBanks" style={{ zIndex: "9999" }}>
                        <ul className="dropdownul">
                          <li
                            className="liHover"
                            onClick={() => {
                              deleteAllBanks(bankName);
                              setBankDropdown(false);
                            }}
                          >
                            Unlink
                          </li>
                        </ul>
                      </div>
                    </React.Fragment>
                  )}{" "}
                </div>
              </div>
              <ListPaginated
                key={index}
                cols={cols}
                rows={bankDetailsLatest[bankName]}
              />
            </div>
          ))}
      </div>

      {detailsModal && (
        <Modal
          visible={detailsModal}
          footer={null}
          onOk={handleCancel}
          onCancel={handleCancel}
          closable={false}
          centered
        >
          <h3 className="modaltitle">Transaction Details</h3>

          <div>
            <div className="" style={{ maxHeight: "18rem", overflow: "auto" }}>
              {updatedObject && updatedObject.length > 0 ? (
                <table id="clients">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody style={{}}>
                    {updatedObject &&
                      updatedObject.map((data, index) => (
                        <tr key={index}>
                          <td>{data.name}</td>
                          <td>
                            {moment(data.date).format("DD-MM-YYYY HH:mm")}
                          </td>
                          <td>{data.amount}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <h3 className="inputTitle">No Transaction to Show</h3>
              )}
            </div>
          </div>

          <div className="buttonsMain" style={{ justifyContent: "center" }}>
            <button
              className="savebutton"
              onClick={() => {
                handleCancel();
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
      {addAccountModal && (
        <Modal
          visible={addAccountModal}
          footer={null}
          onOk={handleCancelAdd}
          onCancel={handleCancelAdd}
          closable={false}
          centered
        >
          <div
            style={{
              maxHeight: "25rem",
              overflowY: "auto",
              background: "#F4F7FE",
            }}
          >
            <div className="selelctmain">
              <h3 className="selectHeading">
                {" "}
                {addPlanAccountData &&
                  addPlanAccountData.liability &&
                  "Liabilities (Loans)"}
              </h3>
              <div className="selectmain">
                {addPlanAccountData &&
                  addPlanAccountData.liability &&
                  addPlanAccountData.liability.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        console.log("item.name", item.name, item.subType);
                        handleAssetSelect(item.name, item.subType);
                      }}
                      className="selectMaincards"
                      style={{ width: "48%" }}
                    >
                      <div
                        className="selectMaincardsInner"
                        style={{ flexWrap: "nowrap" }}
                      >
                        {" "}
                        <div
                          className="selectMainImages"
                          style={{ padding: "10px" }}
                        >
                          <img
                            src={item.image}
                            height={"25px"}
                            alt={item.name}
                          />{" "}
                        </div>
                        <div className="selectMainHeader">
                          <span
                            className="selectheadingValue"
                            style={{ fontSize: "12px" }}
                          >
                            {item.name === "Real Estates"
                              ? "Real Estate"
                              : item.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <h3 className="selectHeading" style={{ marginTop: "1rem" }}>
                {addPlanAccountData && addPlanAccountData.investment
                  ? "Investment"
                  : "Credit"}
              </h3>

              <div className="selectmain">
                {addPlanAccountData &&
                  (addPlanAccountData.investment
                    ? addPlanAccountData.investment
                    : addPlanAccountData.credit
                  ).map((item, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        handleAssetSelect(item.name, item.subType);
                      }}
                      className="selectMaincards"
                      style={{ width: "48%" }}
                    >
                      <div
                        className="selectMaincardsInner"
                        style={{ flexWrap: "nowrap" }}
                      >
                        {" "}
                        <div
                          className="selectMainImages"
                          style={{ padding: "10px" }}
                        >
                          <img
                            src={item.image}
                            height={"25px"}
                            width={"25px"}
                            alt={item.name}
                          />{" "}
                        </div>
                        <div className="selectMainHeader">
                          <span
                            className="selectheadingValue"
                            style={{ fontSize: "12px" }}
                          >
                            {item.name === "Cash"
                              ? "Cash (Checking, Savings, etc.)"
                              : item.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="buttonsMain" style={{ justifyContent: "center" }}>
            <button
              className="savebutton"
              onClick={() => {
                handleCancelAdd();
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
      {syncModal && (
        <Modal
          visible={syncModal}
          footer={null}
          onOk={handleCancelSyncModal}
          onCancel={handleCancelSyncModal}
          closable={false}
          width={620}
          centered
        >
          <h3 className="modaltitle">Match Found</h3>
          <h3 className="modaltitle" style={{ fontSize: "12px" }}>
            Which Account would you like to Consolidate with?
          </h3>
          <div style={{ marginTop: "1rem" }}>
            <h3 className="modaltitle" style={{ textAlign: "center" }}>
              New Financial Account
            </h3>
            <div className="" style={{ maxHeight: "18rem", overflow: "auto" }}>
              {previousData ? (
                <table id="clients">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Account Number</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody style={{}}>
                    {previousData && (
                      <tr>
                        <td>
                          {previousData.bankName
                            ? previousData.bankName
                            : "N/A"}
                        </td>
                        <td>
                          {previousData.accountType
                            ? previousData.accountType
                            : "N/A"}
                        </td>
                        <td>
                          {previousData.mask
                            ? "****" + previousData.mask
                            : "N/A"}
                        </td>
                        <td>
                          {previousData.balance ? previousData.balance : "N/A"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                <h3 className="inputTitle">No Previous Data to Show</h3>
              )}
            </div>
          </div>

          <div style={{ marginTop: "1rem" }}>
            <h3 className="modaltitle" style={{ textAlign: "center" }}>
              Existing Asset Planet Account
            </h3>

            <div className="" style={{ maxHeight: "18rem", overflow: "auto" }}>
              {matchData && matchData.length > 0 ? (
                <table id="clients">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Account Number</th>
                      <th>Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody style={{}}>
                    {matchData &&
                      matchData.map((data, index) => (
                        <tr key={index}>
                          {matchValues
                            .filter((item) => item.clientModuleId === data.id)
                            .map((item, idx) => (
                              <td key={idx}>
                                {item.valueString ? item.valueString : "N/A"}
                              </td>
                            ))}

                          <td>
                            {data.module.name &&
                            data.module.name === "Real Estates"
                              ? "Real Estate"
                              : data.module.name}
                          </td>
                          <td>
                            {data.module.attributes[0].values[0].valueString
                              ? data.module.attributes[0].values[0].valueString
                              : "N/A"}
                          </td>
                          <td>{data.amount ? data.amount : "N/A"}</td>
                          <td>
                            {" "}
                            {console.log(" data[0].managedBy", data)}
                            {data && data && data.managedBy == "Plaid" ? (
                              <button
                                className="saveStatusbutton"
                                style={{
                                  width: "fit-content",
                                  opacity: "0.4",
                                  cursor: "not-allowed",
                                  background: "#2a3da3",
                                }}
                              >
                                {data.accountId &&
                                data.accountId !== previousData.id &&
                                data.accountId &&
                                data.accountId !== null
                                  ? "Consolidated with other"
                                  : "Consolidated"}
                              </button>
                            ) : (
                              <button
                                className="saveStatusbutton"
                                onClick={() => {
                                  console.log(
                                    "previous data",
                                    previousData.id,
                                    data.id
                                  );
                                  setaddPlanPayload({
                                    id: previousData.id,
                                    clientModuleId: data.id,
                                    moduleName: data.module.name,
                                  });
                                  if (
                                    addPlanPayload &&
                                    addPlanPayload.clientModuleId === data.id
                                  ) {
                                    setaddPlanPayload(null);
                                  }
                                  // addAssetToPlan(previousData.id,data.id);
                                }}
                                style={{
                                  width: "fit-content",
                                  background:
                                    addPlanPayload &&
                                    addPlanPayload.clientModuleId === data.id
                                      ? "#09A84D"
                                      : "#2a3da3",
                                }}
                              >
                                {addPlanPayload &&
                                addPlanPayload.clientModuleId === data.id
                                  ? "Selected"
                                  : "Select"}
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <h3 className="inputTitle">No Matched to Show</h3>
              )}
            </div>
          </div>

          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancelSyncModal();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              onClick={() => {
                addAssetToPlan();
                // handleCancelSyncModal();
              }}
              style={{
                opacity:
                  addPlanPayload && addPlanPayload.clientModuleId ? "1" : "0.3",
                cursor:
                  addPlanPayload && addPlanPayload.clientModuleId
                    ? "pointer"
                    : "not-allowed",
              }}
              disabled={
                addPlanPayload && addPlanPayload.clientModuleId ? false : true
              }
            >
              Consolidate
            </button>
          </div>
        </Modal>
      )}
      <Modal
        visible={accountTypeModal}
        footer={null}
        // onOk={handleCancelSyncModal}
        onCancel={handleCancelAccountTypeModal}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Banks Account Type</h3>
        <h3 className="modaltitle" style={{ fontSize: "12px" }}>
          Which Bank Account Type would you like to Add with Asset Planet? If
          you have an Asset AND a Credit at the bank you are adding, click Both
          Types.
        </h3>
        <h3 className="selectHeading"> Select Account Type</h3>
        <div className="selectmain">
          {accountTypes &&
            accountTypes.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  hanldeAccountSelected(item.name);
                }}
                className="selectMaincards"
                style={{ width: "48%" }}
              >
                <div
                  className="selectMaincardsInner"
                  style={{ flexWrap: "nowrap" }}
                >
                  {" "}
                  <div className="selectMainImages" style={{ padding: "10px" }}>
                    <img src={item.image} height={"25px"} alt={item.name} />{" "}
                  </div>
                  <div className="selectMainHeader">
                    <span
                      className="selectheadingValue"
                      style={{ fontSize: "12px" }}
                    >
                      {item.title}
                    </span>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancelAccountTypeModal();
            }}
          >
            Cancel
          </button>
        </div>
        <NewLoader isLoading={bankloading} />
      </Modal>

      <Modal
        visible={bankModal}
        footer={null}
        // onOk={handleCancelSyncModal}
        onCancel={handleCancelBankModal}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Banks</h3>
        <h3 className="modaltitle" style={{ fontSize: "12px" }}>
          Which Bank would you like to Add with Asset Planet?
        </h3>
        <div style={{ marginTop: "1rem" }}>
          <h3 className="modaltitle" style={{ textAlign: "center" }}>
            New Financial Account
          </h3>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "1rem",
              flexWrap: "wrap",
            }}
          >
            <div style={{ marginBottom: "0px", width: "70%" }}>
              <input
                className="searchStyle"
                placeholder="Search Bank"
                onKeyPress={handleKeypress}
                value={searchQuery && searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  if (e.target.value === "") {
                    handleCancelSearch(e);
                  }
                }}
              />
            </div>
            <div className="filterIcons" onClick={handleSearch}>
              <img src={SearchIcon} height={22} width={24} alt="icon"></img>
            </div>

            {searchQuery && searchQuery !== "" && (
              <div
                className="filterIcons"
                onClick={(e) => {
                  handleCancelSearch(e);
                }}
              >
                <img src={deleteIcon} height={22} width={24} alt="icon"></img>
              </div>
            )}
          </div>
          <div className="selectmain" id="bankDisplay" onScroll={handleScroll}>
            {bankList && bankList && bankList.length > 0 ? (
              bankList.map((item, index) => (
                <div
                  key={item.institution_id}
                  onClick={() => {
                    console.log("item.name", item);
                    hanldeBankSelect(item);
                  }}
                  className="selectMaincards"
                  style={{ width: "98%" }}
                >
                  <div className="selectMaincardsInner">
                    {" "}
                    <div
                      className="selectMainImages"
                      style={{ padding: "0px" }}
                    >
                      <img src={plaidIcon} height={48} alt={item.name} />{" "}
                    </div>
                    <div className="selectMainHeader">
                      <span
                        className="selectheadingValue"
                        style={{ fontSize: "16px" }}
                      >
                        {item.name}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <h3
                className="inputTitle"
                style={{ textAlign: "center", width: "100%" }}
              >
                No Bank to Show
              </h3>
            )}
          </div>
        </div>

        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancelBankModal();
            }}
          >
            Cancel
          </button>
        </div>
        <NewLoader isLoading={bankloading} />
      </Modal>
      <Loader isLoading={loading} />
    </div>
  );
};

export default PlaidMainNew;
